import {getChapterIndexByTime} from '@components/LiveEvent/RecordingsPlayer/@utils/getChapterIndexByTime';
import {IChapterCue} from '@utils/parseChapterMarks';
import {useMemo} from 'react';
import {useChaptersStore} from './useChaptersStore';

export const useActiveChapterIndex = (chapters: IChapterCue[]) => {
    const activeChapterTimestamp = useChaptersStore(
        s => s.activeChapterTimestamp,
    );

    return useMemo(() => {
        if (
            activeChapterTimestamp === null ||
            !chapters ||
            chapters.length === 0
        ) {
            return null;
        }

        const activeIndex = getChapterIndexByTime(
            activeChapterTimestamp,
            chapters,
        );

        return activeIndex !== -1 ? activeIndex : 0;
    }, [activeChapterTimestamp, chapters]);
};
